/**
 * @module webdnn/math
 * @preferred
 *
 * Module `WebDNN.Math` provides basic mathematics operations for pre/post-processing.
 */
/** Don't Remove This comment block */
export * from "./math/argsort";



//////////////////
// WEBPACK FOOTER
// ./src/descriptor_runner/math.js
// module id = 43
// module chunks = 0